const onRouteUpdate = () => {
  // No scripts  
}

export { onRouteUpdate }
